var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Filemanager',{attrs:{"selectable":""},on:{"selectedMedia":_vm.handleSelection}})
}
var staticRenderFns = []

export { render, staticRenderFns }